<template>
<modal v-show="modalState.first"
       :container="'modal-container'"
       @close="updateModal('first', false)">
    <template v-slot:header>
        <h3>Your First Scan</h3>
        <button type="button" class="close" aria-label="Close Modal" v-on:click="updateModal('first', false)">
            <span aria-hidden="true">&times;</span>
        </button>
    </template>
    <template v-slot:body>
        <p>Your Autobahn vulnerability scan has been queued and will start shortly. You will receive an email when your scan is complete. Thank you.</p>
    </template>
</modal>
</template>

<script>
import Modal from '~/components/shared/templates/modal.vue';

export default {
    name: 'modals-home',
    components: { Modal },
    props: {
        modalState: {
            first: false,
        },
    },
    methods: {
        updateModal(type, state) {
            this.modalState[type] = state;
            this.$emit('updateModal', {
                key: type,
                state,
            });
        },
    },
};
</script>
